import { render, staticRenderFns } from "./ApmsBasicPlantProtectionBatchSetting.vue?vue&type=template&id=58a6259a&scoped=true&"
import script from "./ApmsBasicPlantProtectionBatchSetting.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicPlantProtectionBatchSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a6259a",
  null
  
)

export default component.exports